import { render, staticRenderFns } from "./PayeeAddressDetails.vue?vue&type=template&id=68ec4784"
import script from "./PayeeAddressDetails.vue?vue&type=script&lang=js"
export * from "./PayeeAddressDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports